import { useLayoutEffect } from 'react'
import { useVODStore } from '@/shared/store'
import { useVODService } from '@/app/context/DIContext/DIServices'
import { selectVodRowItems } from '@/shared/store/storeSelectors/vodSelectors'
import VodItem from '@/features/VOD/vodClasses/vodItem'

export const useItemFetcher = (
    id: number | string,
    setRowItems: (items: VodItem[]) => void,
    getItems: () => Promise<VodItem[]>
) => {
    const vodRowItems = useVODStore(selectVodRowItems)
    const { createId } = useVODService()

    useLayoutEffect(() => {
        setRowItems([])
        const responseId = createId(id)
        const rowItemsToDisplay = vodRowItems.find(
            (item) => item.rowId === responseId
        )

        const handleFetchData = async () => {
            if (rowItemsToDisplay) {
                setRowItems([...rowItemsToDisplay.content])
            } else {
                await getItems()
            }
        }

        handleFetchData()

        return () => {
            setRowItems([])
        }
    }, [id])
}
